import { SELECIONAR_BILHETE, LIMPA_SELECIONAR_BILHETE } from '../types';

export function selecionarBilhete (configuracaoBilhete) {
  return {
    type: SELECIONAR_BILHETE,
    payload: configuracaoBilhete
  }
}

export function limparConfiguracaoBilhete () {
    return {
        type: LIMPA_SELECIONAR_BILHETE,
    }
}
